import { render, staticRenderFns } from "./invitations.vue?vue&type=template&id=613bf731"
import script from "./invitations.vue?vue&type=script&lang=js"
export * from "./invitations.vue?vue&type=script&lang=js"
import style0 from "./invitations.vue?vue&type=style&index=0&id=613bf731&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports